'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  0% { transform: none; }\n  25% { transform: translateY(-6px); }\n  95% { transform: translateY(2px); }\n  100% { transform: none; }\n'], ['\n  0% { transform: none; }\n  25% { transform: translateY(-6px); }\n  95% { transform: translateY(2px); }\n  100% { transform: none; }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  will-change: transform;\n  animation: ', ' 1.4s infinite;\n'], ['\n  will-change: transform;\n  animation: ', ' 1.4s infinite;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  path {\n    stroke: ', ';\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  path {\n    stroke: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icons = require('../../assets/icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var bouncing = (0, _styledComponents.keyframes)(_templateObject);

/*
 * This component will be used inside slides that are
 * not loaded yet.
 */
var Placeholder = function Placeholder(props) {
  return _react2.default.createElement(
    Container,
    null,
    _react2.default.createElement(Icon, { width: '10%', height: null })
  );
};

var Icon = (0, _styledComponents2.default)(_icons.Presa)(_templateObject2, bouncing);

var Container = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.theme.placeholderColor;
});

exports.default = Placeholder;